export class SeriesItem{
    year:number;
    discipline:number;
    series:string;
    constructor(rawItem){
        this.year = rawItem.Year;
        this.discipline=rawItem.Discipline;
        this.series=rawItem.Series;
    }
}